<template>
  <div class="wrapper">
    <div class="btn-toolbar">
      <div class="input-group">
        <input v-model="newname" type="text" class="form-control"/>
        <div class="input-group-append">
          <button @click="addProp()" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
        </div>
      </div>
    </div>
    <div class="wrapper d-flex justify-content-between" v-for="p in data.properties" :key="p.id">
      <!-- <TaskFieldEditor :prop="p"/> -->
      <button class="btn btn-danger"><font-awesome-icon="trash"/></button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UserEventManager',
  props: ["data"],
  data() {
    return {
      newname: '',
    }
  },
  methods: {
    addProp() {
      this.data.properties = this.data.properties || [];
      this.data.properties.push({id: 'field' + this.data.properties.length,name:this.newname});
      this.$forceUpdate();
    }
  }
}
</script>
